import { generatePath } from 'react-router-dom';

import { ROUTER } from 'src/constants';

import { fireToast, history, setNestedValidation, t } from 'utils';

import { errorsStore, form } from 'stores';

import { CHANGE_DISTANCE_FORM, CHANGE_DISTANCE_TOKEN_PARAM } from '../constants';

import { changeDistanceService } from '../services';

import { changeDistanceModalStore } from '../stores';

import { changeDistanceErrorMessage } from '../selections';
import { ChangeDistanceFormData } from '../types';
import { changeDistance } from '../validations';
import { onCancel } from './controls';

export const onSubmit = async () => {
  const data = changeDistanceModalStore.value;

  if (!data) {
    return;
  }

  errorsStore.clear(CHANGE_DISTANCE_FORM);

  const fields = form.fetch<ChangeDistanceFormData>(CHANGE_DISTANCE_FORM);

  if (!setNestedValidation(CHANGE_DISTANCE_FORM, changeDistance, fields)) {
    return;
  }

  const requestedDistanceId = Number(fields.distance?.value);
  const result = await changeDistanceService.createChangeDistanceRequestToken(data.racerId, requestedDistanceId);

  if (!result.ok) {
    fireToast(changeDistanceErrorMessage(result.code, result.message), 'error');
    return;
  }

  const { token, to_distance_id: distanceId } = result.request;

  if (distanceId !== requestedDistanceId) {
    fireToast(t.staticAsString('changeDistance.form.pendingRequest'), 'warning');
  }

  const path = generatePath(ROUTER.RACE_REGISTRATION_WITH_DISTANCE, { id: data.raceId, distanceId });

  onCancel();
  history.push(`${path}&${CHANGE_DISTANCE_TOKEN_PARAM}=${token}`);
};
